import { render, staticRenderFns } from "./EditDateOverlay.vue?vue&type=template&id=2742d7e5&"
import script from "./EditDateOverlay.js?vue&type=script&lang=js&"
export * from "./EditDateOverlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2742d7e5')) {
      api.createRecord('2742d7e5', component.options)
    } else {
      api.reload('2742d7e5', component.options)
    }
    module.hot.accept("./EditDateOverlay.vue?vue&type=template&id=2742d7e5&", function () {
      api.rerender('2742d7e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/EditDateOverlay/EditDateOverlay.vue"
export default component.exports